export const config = {
	BASE_ENGAGE_URL: 'https://engage-api.dev.aws.chartspan.com/'
};